import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export const SongList: React.FC = () => {
  const [songs, setSongs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSongs = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('songs')
          .select('*')
          .order('title');
          
        if (error) throw error;
        
        // Process the URLs to ensure they're public URLs
        const processedSongs = data?.map(song => ({
          id: song.id,
          title: song.title,
          artist: song.artist,
          audio_url: song.audio_url,
          lead_vocal_url: song.lead_vocal_url,
          cover_url: song.cover_url,
          lyrics_url: song.lyrics_url,
          duration: song.duration,
          genre: song.genre,
          difficulty: song.difficulty,
          release_year: song.release_year,
          catalog_number: song.catalog_number
        }));

        setSongs(processedSongs || []);
      } catch (err) {
        console.error('Error fetching songs:', err);
        setError('Failed to load songs');
      } finally {
        setLoading(false);
      }
    };

    fetchSongs();
  }, []);

  if (loading) {
    return <div className="p-4">Loading songs...</div>;
  }

  if (error) {
    return <div className="p-4 text-red-500">Error: {error}</div>;
  }

  return (
    <div className="p-4 bg-kod-purple-900 min-h-screen">
      <pre className="text-white overflow-auto">{JSON.stringify(songs, null, 2)}</pre>
    </div>
  );
};